import './App.css';
import Footer from './components/footer/Footer';
import Home from './components/Home/Home';
import Login from './components/Login/Login';
import { BrowserRouter as Router, Route, Link, Routes }
  from "react-router-dom";
import Support from './components/support/Support';
import Myprofile from './components/myprofile/Myprofile';
import AboutUs from './components/About/AboutUs';
import InitialSWOT from './components/initialSWOT/InitialSWOT';
import Material from './components/Material/Material';
import InnerMaterial from './components/Material/InnerMaterial';
import CalendarPage from './components/Calender/calender';
import CalendarDetail from './components/Calender/CalendarDetail';
import Recording from './components/Recording/Recording';
import Backup from './components/backup/Backup';
import BackupSeats from './components/backup/BackupSeats';
import BookedclassDetail from './components/backup/BookedClass';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { AttendanceProvider } from './components/AttendanceContext';

function App() {
  return (
    <div className="">
      <ToastContainer/>
      <Router>
      <Routes>
        <Route exact path="/" element={<Login />} />
        <Route
          path="/*"
          element={
            <AttendanceProvider>
              <Routes>
                <Route exact path="/home" element={<Home />} />
                <Route exact path="/support" element={<Support />} />
                <Route exact path="/myProfile" element={<Myprofile />} />
                <Route exact path="/aboutUs" element={<AboutUs />} />
                <Route exact path="/initialSWOT" element={<InitialSWOT />} />
                <Route exact path="/material" element={<Material />} />
                <Route exact path="/materialDetail" element={<InnerMaterial />} />
                <Route exact path="/calendar" element={<CalendarPage />} />
                <Route exact path="/classdetails" element={<CalendarDetail />} />
                <Route exact path="/recording" element={<Recording />} />
                <Route exact path="/backup" element={<Backup />} />
                <Route exact path="/backupclasses" element={<BackupSeats />} />
                <Route exact path="/bookedclassDetail" element={<BookedclassDetail />} />
              </Routes>
            </AttendanceProvider>
          }
        />
      </Routes>
    </Router>
    </div>
  );
}

export default App;
